import { render, staticRenderFns } from "./SignUpBeneficialOwnerComponent.vue?vue&type=template&id=1b224fb2&scoped=true&"
import script from "./SignUpBeneficialOwnerComponent.vue?vue&type=script&lang=js&"
export * from "./SignUpBeneficialOwnerComponent.vue?vue&type=script&lang=js&"
import style0 from "./SignUpBeneficialOwnerComponent.vue?vue&type=style&index=0&id=1b224fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b224fb2",
  null
  
)

export default component.exports